import { createSlice } from '@reduxjs/toolkit';

const confirmationDialog = createSlice({
    name: 'dialog',
    initialState: {
        open: false,
        title: "Warning",
        content: 'Are you sure you want to delete it?',
        onClose: undefined,
        confirmBtnTitle: undefined,
        isLoading: false,
        isSuccess: false,
        error: null,
        onConfirm: () => { },
    },
    reducers: {
        openConfirmDialog: (state, action) => {
            state.title = action?.payload?.title ?? "Warning"
            state.content = action?.payload?.content ?? 'Are you sure you want to delete it?'
            state.onConfirm = action?.payload?.onConfirm ?? null
            state.onClose = action?.payload?.onClose ?? undefined
            state.confirmBtnTitle = action?.payload?.confirmBtnTitle ?? undefined
            state.open = true;
        },
        setStatus: (state, action) => {
            state.isLoading = action?.payload?.isLoading ?? false;
            state.isSuccess = action?.payload?.isSuccess ?? false;
            state.error = action?.payload?.error ?? null;
        },
        closeConfirmDialog: (state) => {
            state.open = false;
            state.title = 'Warning'
            state.content = 'Are you sure you want to delete it?'
            state.onConfirm = () => { }
            state.onClose = undefined
            state.confirmBtnTitle = undefined
            state.isLoading = false;
            state.isSuccess = false;
            state.error = null;
        },
    },
});

export const { openConfirmDialog, closeConfirmDialog, setStatus } = confirmationDialog.actions

export default confirmationDialog.reducer
